<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.data_prepared_at') }}</label></td>
      <td>{{ details.data_prepared_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.garage_number') }}</label></td>
      <td>{{ details.garage_number }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.route') }}</label></td>
      <td>{{ details.route }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.schedule') }}</label></td>
      <td>{{ details.schedule }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.driver_initials') }}</label></td>
      <td>{{ details.driver_initials }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.shift') }}</label></td>
      <td>{{ details.shift }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.time_card') }}</label></td>
      <td>{{ details.time_card }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.starts_at') }}</label></td>
      <td>{{ details.starts_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.ends_at') }}</label></td>
      <td>{{ details.ends_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.schedule_end') }}</label></td>
      <td>{{ details.schedule_end | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.trip_code') }}</label></td>
      <td>{{ details.trip_code }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.direction_id') }}</label></td>
      <td>{{ details.direction_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.direction_type') }}</label></td>
      <td>{{ details.direction_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.low_floor') }}</label></td>
      <td>{{ details.low_floor | int_bool }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.operator_id') }}</label></td>
      <td>{{ details.operator_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.trip_id') }}</label></td>
      <td>{{ details.trip_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.trip_start') }}</label></td>
      <td>{{ details.trip_start }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptSchedule.details.trip_end') }}</label></td>
      <td>{{ details.trip_end }}</td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'ptScheduleDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
